export const otpQueryKeys = {
  generateSecretDoubleAuthentification: (emailOrConnectId?: string) =>
    ["generate-2fa", emailOrConnectId] as const,
};
